import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import client from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const run = async () => {
            const hash = window.location.hash || "";
            const m = hash.match(/session_id=([^&]+)/);
            if (!m) {
                navigate("/login");
                return;
            }
            try {
                const { data } = await client.post("/auth/session", { session_id: m[1] });
                setUser(data.user);
                // Clear hash and go to dashboard
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/dashboard", { state: { user: data.user } });
            } catch {
                navigate("/login");
            }
        };
        run();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="text-center">
                <div className="inline-block h-8 w-8 animate-spin rounded-full border-2 border-gold border-t-transparent"></div>
                <p className="mt-4 text-navy-500 font-sans">Establishing secure session...</p>
            </div>
        </div>
    );
}
